{
  "name": "@geoman-io/leaflet-geoman-free",
  "version": "2.20.3",
  "description": "A Leaflet Plugin For Editing Geometry Layers in Leaflet 1.0",
  "keywords": [
    "leaflet",
    "geoman",
    "polygon management",
    "geometry editing",
    "map data",
    "map overlay",
    "polygon",
    "geojson",
    "leaflet-draw",
    "data-field-geojson",
    "ui-leaflet-draw"
  ],
  "files": [
    "dist/leaflet-geoman.js",
    "dist/leaflet-geoman.min.js",
    "dist/leaflet-geoman.css",
    "dist/leaflet-geoman.d.ts",
    "dist/leaflet-geoman.js.map",
    "dist/leaflet-geoman.min.js.map",
    "dist/leaflet-geoman.css.map"
  ],
  "main": "dist/leaflet-geoman.js",
  "module": "dist/leaflet-geoman.js",
  "types": "dist/leaflet-geoman.d.ts",
  "exports": {
    ".": {
      "types": "./dist/leaflet-geoman.d.ts",
      "import": "./dist/leaflet-geoman.js",
      "require": "./dist/leaflet-geoman.js",
      "default": "./dist/leaflet-geoman.js"
    },
    "./dist/leaflet-geoman.css": "./dist/leaflet-geoman.css"
  },
  "dependencies": {
    "@turf/boolean-contains": "^7.4.0",
    "@turf/kinks": "^7.4.0",
    "@turf/line-intersect": "^7.4.0",
    "@turf/line-split": "^7.4.0",
    "lodash": "4.18.1",
    "polyclip-ts": "^0.16.8"
  },
  "devDependencies": {
    "@types/geojson": "^7946.0.16",
    "@types/leaflet": "^1.9.22",
    "@types/lodash": "^4.17.26",
    "@types/node": "^20.19.43",
    "@vitest/coverage-v8": "^4.1.11",
    "cross-env": "^10.1.0",
    "cypress": "^16.1.1",
    "esbuild": "^0.28.2",
    "husky": "^9.1.7",
    "leaflet": "1.9.4",
    "lint-staged": "^17.6.0",
    "oxfmt": "^0.72.0",
    "oxlint": "^1.87.0",
    "prosthetic-hand": "2.2.2",
    "tsx": "^4.23.15",
    "typescript": "^6.0.3",
    "vitest": "^4.1.11"
  },
  "peerDependencies": {
    "leaflet": "^1.2.0"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "packageManager": "pnpm@12.5.1",
  "scripts": {
    "start": "pnpm run dev",
    "dev": "cross-env DEV=true tsx bundle.mts",
    "build": "tsx bundle.mts",
    "test": "cypress run --browser chrome",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest",
    "test:unit:coverage": "vitest run --coverage",
    "test:all": "pnpm run test:unit && pnpm run test",
    "cypress": "cypress open",
    "prepare": "pnpm run build && husky",
    "lint": "oxlint src demo cypress test test-page.ts bundle.mts vitest.config.ts cypress.config.ts --fix && oxfmt --write src demo cypress test test-page.ts bundle.mts vitest.config.ts cypress.config.ts",
    "lint:check": "oxlint src demo cypress test test-page.ts bundle.mts vitest.config.ts cypress.config.ts && oxfmt --check src demo cypress test test-page.ts bundle.mts vitest.config.ts cypress.config.ts",
    "typecheck": "tsc --noEmit && tsc --noEmit -p tsconfig.tools.json && tsc --noEmit -p cypress/tsconfig.json && tsc --noEmit -p demo/tsconfig.json && tsc --noEmit -p test/types/tsconfig.json"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/geoman-io/leaflet-geoman.git"
  },
  "author": {
    "name": "Geoman.io",
    "email": "sales@geoman.io",
    "url": "http://geoman.io"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/geoman-io/leaflet-geoman/issues"
  },
  "homepage": "https://geoman.io",
  "lint-staged": {
    "*.{js,ts,mjs,mts,cts}": "oxlint --fix",
    "*.{js,ts,mjs,mts,cts,css}": "oxfmt --write"
  }
}
